import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48f4ebf0")

_pushScopeId("data-v-48f4ebf0")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = { class: "dialog-box" }
const _hoisted_4 = { class: "dialog-box-title" }
const _hoisted_5 = { class: "dialog-box-title-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-spacer" }, null, -1)
const _hoisted_7 = { class: "dialog-box-contents" }
const _hoisted_8 = { class: "dialog-box-contents-contents" }
const _hoisted_9 = {
  key: 0,
  class: "dialog-box-contents-contents-listname"
}
const _hoisted_10 = { class: "dialog-box-contents-contents-listname-text" }
const _hoisted_11 = {
  key: 1,
  class: "dialog-box-contents-contents-spacer"
}
const _hoisted_12 = { class: "dialog-box-contents-contents-mode" }
const _hoisted_13 = { class: "dialog-box-contents-contents-mode-text" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-spacer" }, null, -1)
const _hoisted_15 = { class: "dialog-box-contents-contents-time" }
const _hoisted_16 = { class: "dialog-box-contents-contents-time-text" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-spacer" }, null, -1)
const _hoisted_18 = { class: "dialog-box-contents-contents-setting" }
const _hoisted_19 = { class: "dialog-box-contents-contents-setting-text" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-spacer" }, null, -1)
const _hoisted_21 = {
  key: 2,
  class: "dialog-box-contents-contents-note"
}
const _hoisted_22 = { class: "dialog-box-contents-contents-note-text" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-contents-spacer" }, null, -1)
const _hoisted_24 = { class: "dialog-box-bottom" }
const _hoisted_25 = { class: "dialog-box-bottom-negative-text" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-bottom-spacer" }, null, -1)
const _hoisted_27 = { class: "dialog-box-bottom-positive-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.displayTitle), 1)
              ]),
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  (_ctx.listName)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.listName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.listName)
                    ? (_openBlock(), _createBlock("div", _hoisted_11))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.modeName), 1)
                  ]),
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.timeText), 1)
                  ]),
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, [
                    _createVNode("span", _hoisted_19, _toDisplayString(_ctx.settingText), 1)
                  ]),
                  _hoisted_20,
                  (_ctx.isValidFrozenMessage)
                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                        _createVNode("span", _hoisted_22, _toDisplayString(_ctx.noteText), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_23
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", {
                  class: "dialog-box-bottom-negative",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelClicked(...args)))
                }, [
                  _createVNode("div", _hoisted_25, _toDisplayString(_ctx.cancelText), 1)
                ]),
                _hoisted_26,
                _createVNode("div", {
                  class: "dialog-box-bottom-positive",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendClicked(...args)))
                }, [
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.sendText), 1)
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})